import React from "react";
import OAuthCallbackShell from "./OAuthCallbackShell";

const buildPayload = (params) => ({
  code:  params.get("code")  || "",
  state: params.get("state") || "",
});

const GoogleAdsCallback = () => (
  <OAuthCallbackShell
    platform="Google Ads"
    endpoint="/api/ads-auth/google/callback"
    buildPayload={buildPayload}
  />
);

export default GoogleAdsCallback;
